import Button from "@/components/base/Button";
import { useSiteData } from "@/context/SiteDataContext";
import { useT } from "@/lib/useSiteText";

interface CTASectionProps {
  titulo?: string;
  descripcion?: string;
}

export default function CTASection({ titulo, descripcion }: CTASectionProps) {
  const { whatsappLink } = useSiteData();
  const t = useT();
  const imagen = t("comun.cta.imagen");
  const nota = t("comun.cta.nota");
  const descripcionFinal = descripcion ?? t("comun.cta.descripcion");
  return (
    <section className="relative overflow-hidden bg-primary-800">
      {imagen && (
        <div
          className="absolute inset-0 opacity-20"
          style={{
            backgroundImage: `url("${imagen.replace(/"/g, "%22")}")`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        />
      )}
      <div className="absolute inset-0 bg-gradient-to-b from-primary-900/70 via-primary-900/60 to-primary-900/70" />
      <div className="relative mx-auto max-w-4xl px-4 md:px-6 py-16 md:py-20 text-center">
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50">{titulo ?? t("comun.cta.titulo")}</h2>
        <p className="mt-4 text-base md:text-lg text-background-200 max-w-2xl mx-auto">{descripcionFinal}</p>
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Button to="/contacto" variant="accent" icon="ri-calendar-check-line" className="w-full sm:w-auto">
            {t("comun.cta.boton_visita")}
          </Button>
          <Button href={whatsappLink()} className="w-full sm:w-auto bg-background-50 text-primary-800 hover:bg-background-100" icon="ri-whatsapp-line">
            {t("comun.cta.boton_whatsapp")}
          </Button>
        </div>
        {nota && <p className="mt-5 text-sm text-background-300">{nota}</p>}
      </div>
    </section>
  );
}